module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "a-midsummer-nights-dream"
    }
  }, [_c('h2', [_vm._v("A Midsummer Night’s Dream")]), _vm._v(" "), _c('p', [_vm._v("Tucked away in a tranquil street")]), _vm._v(" "), _c('p', [_vm._v("That we stumbled upon simply by chance")]), _vm._v(" "), _c('p', [_vm._v("Delicate diamonds fell from the Heavens")]), _vm._v(" "), _c('p', [_vm._v("And across the black asphalt, the city lights danced")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Your hand gently rested at the small of my back")]), _vm._v(" "), _c('p', [_vm._v("As soft laughter resonated from the café alongside")]), _vm._v(" "), _c('p', [_vm._v("Where cigarettes dangled between Parisian fingertips")]), _vm._v(" "), _c('p', [_vm._v("And glasses were raised to the beauty of life.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdc24252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0002.vue
// module id = 87
// module chunks = 0